import cx from 'classnames'
import {
  forwardRef,
  ForwardedRef,
  InputHTMLAttributes,
  DetailedHTMLProps,
} from 'react'

type InputProps = {
  label?: string
  id?: string
  name?: string
  type?: string
  placeholder?: string
  value?: string
  register?: any
  error?: string
  inputSize?: string
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

const Input = forwardRef(
  (
    {
      label,
      id,
      name,
      type = 'text',
      register,
      error,
      placeholder,
      inputSize = 'large',
      ...rest
    }: InputProps,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    return (
      <div className="formControl">
        {label && (
          <label className="formControl-label" htmlFor={id ?? name}>
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={cx('formControl-input', inputSize, error && 'error')}
          id={id ?? name}
          type={type}
          name={name}
          placeholder={placeholder}
          {...(register && name ? register(name) : {})}
          {...rest}
        />
        {error && <span className="formControl-error">{error}</span>}
      </div>
    )
  },
)

// Añadimos un displayName para mejorar la depuración
Input.displayName = 'Input'

export default Input
